export function cleanHtmlString(htmlString: string) {
  // Remove incorrectly escaped quotes
  htmlString = htmlString.replace(/\\&quot;/g, '"');

  // Fix improperly formatted style attributes
  htmlString = htmlString.replace(
    /style="\\"([^"]*)\\""/g,
    function (match, p1) {
      return `style="${p1}"`;
    }
  );

  // Fix improperly formatted style attributes with missing quotes around attribute values
  htmlString = htmlString.replace(
    /style="([^"]*?)\\?["' ]([^"]*?)\\?["' ]([^"]*?)"/g,
    'style="$1:$2;$3"'
  );

  // Remove any remaining incorrect escape sequences
  htmlString = htmlString.replace(/\\"/g, '"');

  return htmlString;
}

export const webSafeFonts = [
  "Andale Mono",
  "Arial",
  "Arial Black",
  "Book Antiqua",
  "Comic Sans MS",
  "Courier New",
  "Georgia",
  "Helvetica",
  "Impact",
  "Symbol",
  "Tahoma",
  "Terminal",
  "Times New Roman",
  "Trebuchet MS",
  "Verdana",
  "Webdings",
  "Palatino",
  "Gill Sans",
  "Lucida Sans",
  "Franklin Gothic Medium",
  "Garamond",
  "Baskerville",
  "Optima",
  "Candara",
  "Geneva",
  "Century Gothic",
  "Lucida Console",
  "Lucida Grande",
  "Monaco",
  "Bradley Hand",
  "Brush Script MT",
  "Luminari",
  "Arial Narrow",
  "Didot",
  "American Typewriter",
  "Courier",
  "Avant Garde",
];
